var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      staticStyle: { "overflow-y": "hidden" },
      attrs: { persistent: "" },
      model: {
        value: _vm.dialogGroupName,
        callback: function($$v) {
          _vm.dialogGroupName = $$v
        },
        expression: "dialogGroupName"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card",
            {
              staticStyle: { "box-shadow": "none !important" },
              attrs: { tile: "" }
            },
            [
              _c(
                "v-toolbar",
                {
                  staticStyle: { background: "#2562af !important" },
                  attrs: { card: "" }
                },
                [
                  _c(
                    "v-toolbar-title",
                    { staticClass: "white--text CSChatThai" },
                    [_vm._v("ชื่อกลุ่ม")]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { dark: "", icon: "", flat: "" },
                      on: {
                        click: function($event) {
                          return _vm.closeDialog(false)
                        }
                      }
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: {
                            color: "white !important",
                            "font-size": "20px !important"
                          }
                        },
                        [_vm._v("clear")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticStyle: { height: "30vh", overflow: "scroll" } },
            [
              _c("v-text-field", {
                attrs: {
                  solo: "",
                  placeholder: "ชื่อกลุ่ม",
                  counter: "40",
                  height: "35"
                },
                model: {
                  value: _vm.Groupname,
                  callback: function($$v) {
                    _vm.Groupname = $$v
                  },
                  expression: "Groupname"
                }
              }),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "btnSave",
                  attrs: {
                    small: "",
                    disabled: _vm.Groupname.length > 40 ? true : false
                  },
                  on: {
                    click: function($event) {
                      return _vm.Save_Groupname()
                    }
                  }
                },
                [_vm._v("บันทึก")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13764ed2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13764ed2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mail/Edit/edit_groupname.vue
// module id = null
// module chunks = 